import React, { useRef, useState } from "react";
import * as styles from "./SignsOverlay.module.scss";
import classNames from "classnames";
import ModalOverlay from "@app/components/Modal";
import { Col, Container, Row } from "react-bootstrap";
import Hint from "@app/components/Hint";
import FormBuilder from "@app/components/FormBuilder";
import Button from "@app/components/Button";
import Config from "@app/constants/Config";
import Modal from "@app/components/Modal";

const WarningSignAlert = ({ show, setShow }) => {
	return (
		<Modal
			hasCloseButton={true}
			header={"Neues Warnschild erfasst"}
			size={"md"}
			buttons={
				<Button
					label={"Ok"}
					callback={() => {
						setShow(false);
					}}
					isSubmit={true}
				/>
			}
			show={show}
			onHide={() => setShow(false)}
		>
			<div className={"text-big"}>Bitte Arbeitsplatz auf diese Gefährdung hin überprüfen</div>
		</Modal>
	);
};

const SignsOverlay = ({ header, subheader, show, instantErrors, values, fieldsets, onSave, onCancel }) => {
	const signsOverlayClassName = classNames({
		[styles["signs-overlay"]]: true,
	});
	const prevWarneichen = useRef([...(values?.warnhinweise_warnhinweise_warnzeichen_warnzeichen || [])]);
	const [showWarninSignAlert, setShowWarninSignAlert] = useState(false);

	// add icons
	fieldsets
		.flatMap((field) => field.elements)
		.filter((field) => field.elementType === "accordion")
		.forEach((field) => {
			field.icon = `${Config.API.BASE_PATH}/fileadmin/user_upload/icons/general/${field.name.split("_")[2]}.svg`;
		});

	const Navigation = ({ formikProps }) => {
		return (
			<div className={"modal-buttons"}>
				<Button label={"Abbrechen"} type={"secondary"} callback={onCancel} />
				<Button
					label={"Speichern"}
					callback={() => {
						const newWarneichen = formikProps.values.warnhinweise_warnhinweise_warnzeichen_warnzeichen;
						const additionalWarnzeichen = !!newWarneichen?.find(
							(newEntry) => !prevWarneichen.current.includes(newEntry),
						);
						prevWarneichen.current = newWarneichen;
						onSave?.(formikProps.values);
						setShowWarninSignAlert(additionalWarnzeichen);
					}}
					// isSubmit={true}
				/>
			</div>
		);
	};

	return (
		<>
			<ModalOverlay
				header={header}
				subheader={subheader}
				show={show}
				fullscreen={true}
				onHide={() => {
					onCancel?.();
				}}
				className={signsOverlayClassName}
			>
				{instantErrors?.length > 0 && (
					<div ref={errorHintRef}>
						<Container>
							<Row>
								<Col className="pt-30">
									<Hint label={"Bitte füllen Sie zum Fortfahren die markierten Felder aus."} />
								</Col>
							</Row>
						</Container>
					</div>
				)}
				<FormBuilder
					// values={editItem ? editItem : getInitialValues(fieldsetElements)}
					values={values}
					// onChange={({ formikProps, formikFields }) => {
					// 	console.log("onChange", formikProps.values);
					// }}
					isOverlay={true}
					isSubPage={true}
					fieldsets={fieldsets}
					instantErrors={instantErrors}
					Navigation={Navigation}
					proceedInvalid={false}
				/>
			</ModalOverlay>
			<WarningSignAlert show={showWarninSignAlert} setShow={setShowWarninSignAlert} />
		</>
	);
};

SignsOverlay.propTypes = {};

export default SignsOverlay;
